module.exports = __webpack_public_path__ + "static/media/playstore.d05e9511.png";